import toast, { type ToastOptions } from 'react-hot-toast'

function showToast(
  type: 'error' | 'success',
  message: string,
  options?: ToastOptions
) {
  toast.dismiss()
  if (type === 'error') {
    toast.error(message, options)
  } else {
    toast.success(message, options)
  }
}

export function showErrorToast(message: string, options?: ToastOptions) {
  showToast('error', message, options)
}

export function showSuccessToast(message: string, options?: ToastOptions) {
  showToast('success', message, options)
}
